import React from 'react';
import { motion } from 'framer-motion';

const NavBtn = ({ icon: Icon, label, id, active, set, isRTL }) => {
  const isActive = active === id;

  return (
    <motion.button
      onClick={() => set(id)}
      whileHover={{ x: isRTL ? -4 : 4 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
      className={`
        w-full flex items-center px-3 py-2.5 mb-1 rounded-xl relative
        transition-colors duration-200 group
        ${isActive
          ? `bg-[#C47A2C]/12 dark:bg-[#C47A2C]/15 text-[#C47A2C] font-semibold`
          : `text-[#1B263B]/60 dark:text-white/50
             hover:text-[#1B263B] dark:hover:text-white
             hover:bg-[#1B263B]/5 dark:hover:bg-white/5`
        }
      `}
    >
      {/* Left accent bar */}
      <span
        className={`
          absolute ${isRTL ? 'right-0' : 'left-0'} top-1/2 -translate-y-1/2
          w-[3px] rounded-full transition-all duration-300
          ${isActive ? 'h-[60%] bg-[#C47A2C] shadow-[0_0_8px_rgba(196,122,44,0.6)]' : 'h-0 bg-transparent'}
        `}
      />

      {/* Icon */}
      {/* Icon */}
      <Icon
        className={`w-[18px] h-[18px] flex-shrink-0 transition-all duration-200 ${isRTL ? 'ml-3' : 'mr-3'}
          ${isActive
            ? 'text-[#C47A2C] drop-shadow-[0_0_6px_rgba(196,122,44,0.5)]'
            : 'group-hover:text-[#C47A2C]/70'
          }`}
      />

      {/* Label */}
      <span className={`text-[0.82rem] tracking-wide flex-1 ${isRTL ? 'text-right' : 'text-left'}`}>
        {label}
      </span>

      {/* Active indicator dot */}
      {isActive && (
        <motion.span
          layoutId="nav-active-dot"
          className={`w-1.5 h-1.5 rounded-full bg-[#C47A2C] ${isRTL ? 'mr-1' : 'ml-1'} shadow-[0_0_6px_rgba(196,122,44,0.7)]`}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        />
      )}
    </motion.button>
  );
};

export default NavBtn;
